import DamWebSocketClient from '../dam/DamWebSocketClient';
import UamfWebSocketKeepAliveManager from './uamfWebSocketKeepAliveManager';

const config = {
    logPrefix: 'uamfWebSocketClient',
    KeepAliveManagerClass: UamfWebSocketKeepAliveManager,
};

export default class UamfWebSocketClient extends DamWebSocketClient {
    constructor(assetId, isCreateNew, options, serialNumber) {
        super(assetId, isCreateNew, options, serialNumber, config);
    }

    // WebSocket is alive as long as the subscription response expiresAt is alive
    getExpiry(options) {
        const {expiresAt} = options;

        if (!expiresAt) {
            throw new Error('uamfWebSocketClient: subscription response has no expiresAt value');
        }

        return expiresAt * 1000;
    }
}
